export class TextureDataDTO {
  public textureUrl: string;
  public bumpMapUrl?: string;
  public glossMapUrl?: string;
  public normalMapUrl?: string;
  public roughness?: number;
  public metalness?: number;
  public color?: string;
  public bumpScale?: number;
  public uvMapScale?: number;
  public normalMapScale?: number[];
  public colorInfo?: string;
  public sheen?: number;
  public sheenColor?: string;
  public specularIntensity?: number;
  public specularColor?: string;
  public defaultColorId?: string;
  public ior?: number;

  // NEW PROPERTIES
  public anisotropy?: number;
  public anisotropyRotation?: number;
  public attenuationColor?: string;
  public attenuationDistance?: number;
  public clearcoat?: number;
  public clearcoatRoughness?: number;
  public dispersion?: number;
  public reflectivity?: number;
  public iridescence?: number;
  public iridescenceIOR?: number;
  public thickness?: number;
  public transmission?: number;

  public thicknessMapUrl?: string;
  public specularIntensityMapUrl?: string;
  public sheenColorMapUrl?: string;
  public sheenRoughnessMapUrl?: string;
  public iridescenceThicknessMapUrl?: string;
  public iridescenceMapUrl?: string;
  public clearcoatRoughnessMapUrl?: string;
  public clearcoatNormalMapUrl?: string;
  public anisotropyMapUrl?: string;

  constructor(
    textureUrl: string,
    bumpMapUrl?: string,
    glossMapUrl?: string,
    normalMapUrl?: string,
    roughness?: number,
    metalness?: number,
    color?: string,
    bumpScale?: number,
    uvMapScale?: number,
    normalMapScale?: number[],
    colorInfo?: string,
    sheen?: number,
    sheenColor?: string,
    specularIntensity?: number,
    specularColor?: string,
    defaultColorId?: string,
    ior?: number,

    // NEW CONSTRUCTOR PARAMS
    anisotropy?: number,
    anisotropyRotation?: number,
    attenuationColor?: string,
    attenuationDistance?: number,
    clearcoat?: number,
    clearcoatRoughness?: number,
    dispersion?: number,
    reflectivity?: number,
    iridescence?: number,
    iridescenceIOR?: number,
    thickness?: number,
    transmission?: number,

    thicknessMapUrl?: string,
    specularIntensityMapUrl?: string,
    sheenColorMapUrl?: string,
    sheenRoughnessMapUrl?: string,
    iridescenceThicknessMapUrl?: string,
    iridescenceMapUrl?: string,
    clearcoatRoughnessMapUrl?: string,
    clearcoatNormalMapUrl?: string,
    anisotropyMapUrl?: string,
  ) {
    this.textureUrl = textureUrl;
    this.bumpMapUrl = bumpMapUrl;
    this.glossMapUrl = glossMapUrl;
    this.normalMapUrl = normalMapUrl;
    this.roughness = roughness;
    this.metalness = metalness;
    this.color = color;
    this.bumpScale = bumpScale;
    this.uvMapScale = uvMapScale;
    this.normalMapScale = normalMapScale;
    this.colorInfo = colorInfo;
    this.sheen = sheen;
    this.sheenColor = sheenColor;
    this.specularIntensity = specularIntensity;
    this.specularColor = specularColor;
    this.defaultColorId = defaultColorId;
    this.ior = ior;

    // NEW ASSIGNMENTS
    this.anisotropy = anisotropy;
    this.anisotropyRotation = anisotropyRotation;
    this.attenuationColor = attenuationColor;
    this.attenuationDistance = attenuationDistance;
    this.clearcoat = clearcoat;
    this.clearcoatRoughness = clearcoatRoughness;
    this.dispersion = dispersion;
    this.reflectivity = reflectivity;
    this.iridescence = iridescence;
    this.iridescenceIOR = iridescenceIOR;
    this.thickness = thickness;
    this.transmission = transmission;

    this.thicknessMapUrl = thicknessMapUrl;
    this.specularIntensityMapUrl = specularIntensityMapUrl;
    this.sheenColorMapUrl = sheenColorMapUrl;
    this.sheenRoughnessMapUrl = sheenRoughnessMapUrl;
    this.iridescenceThicknessMapUrl = iridescenceThicknessMapUrl;
    this.iridescenceMapUrl = iridescenceMapUrl;
    this.clearcoatRoughnessMapUrl = clearcoatRoughnessMapUrl;
    this.clearcoatNormalMapUrl = clearcoatNormalMapUrl;
    this.anisotropyMapUrl = anisotropyMapUrl;
  }

  clone(): TextureDataDTO {
    return new TextureDataDTO(
      this.textureUrl,
      this.bumpMapUrl,
      this.glossMapUrl,
      this.normalMapUrl,
      this.roughness,
      this.metalness,
      this.color,
      this.bumpScale,
      this.uvMapScale,
      this.normalMapScale,
      this.colorInfo,
      this.sheen,
      this.sheenColor,
      this.specularIntensity,
      this.specularColor,
      this.defaultColorId,
      this.ior,

      this.anisotropy,
      this.anisotropyRotation,
      this.attenuationColor,
      this.attenuationDistance,
      this.clearcoat,
      this.clearcoatRoughness,
      this.dispersion,
      this.reflectivity,
      this.iridescence,
      this.iridescenceIOR,
      this.thickness,
      this.transmission,

      this.thicknessMapUrl,
      this.specularIntensityMapUrl,
      this.sheenColorMapUrl,
      this.sheenRoughnessMapUrl,
      this.iridescenceThicknessMapUrl,
      this.iridescenceMapUrl,
      this.clearcoatRoughnessMapUrl,
      this.clearcoatNormalMapUrl,
      this.anisotropyMapUrl,
    );
  }
}
